import {
  Typography,
  Card,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { KytLabel } from "../../../components/Label/kyt";
import { formatDateTime } from "../../../utils/paymentFormat";

const Address = ({ value }: { value: string }) => (
  <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 13, overflowWrap: "anywhere" }}>
    {value}
  </Typography>
);

// The KYT screenings of the order's addresses, one line each.
function InfoKytTab({ kyts }: { kyts: any[] }) {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));

  if (kyts.length === 0) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("KYT screening")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Risk rating of each address checked for this transaction.")}
          </Typography>
        </Box>
      )}
      <AnimatedBlock>
        {isMobile ? (
          kyts.map((kyt) => (
            <Card key={kyt.id} sx={{ mb: 2 }}>
              <Box px={2} py={1}>
                <InfoRow label={t("Address")}>
                  <Address value={kyt.address} />
                </InfoRow>
                <InfoRow label={t("Rating")}>
                  <KytLabel fontSize="small" statusField="rating" record={kyt} />
                </InfoRow>
                <InfoRow label={t("Checked on")}>{formatDateTime(kyt.dateLastUpdated)}</InfoRow>
              </Box>
            </Card>
          ))
        ) : (
          <Card>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Address")}</TableCell>
                    <TableCell>{t("Rating")}</TableCell>
                    <TableCell align="right">{t("Checked on")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {kyts.map((kyt) => (
                    <TableRow key={kyt.id} hover>
                      <TableCell>
                        <Address value={kyt.address} />
                      </TableCell>
                      <TableCell sx={{ whiteSpace: "nowrap" }}>
                        <KytLabel fontSize="small" statusField="rating" record={kyt} />
                      </TableCell>
                      <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                        {formatDateTime(kyt.dateLastUpdated)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        )}
      </AnimatedBlock>
    </Box>
  );
}

export default InfoKytTab;
